import { Component, computed, ElementRef, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ErrorSnackbarComponent } from '../custom/error-snackbar/error-snackbar.component';

import { Injectable } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Subscription, tap } from 'rxjs';
import { FCMService } from 'src/app/services/fcm.service';
import { environment } from 'src/environments/environment';
import { NgOptimizedImage } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { ThemeService } from 'src/app/services/theme.service';

@Injectable({
  providedIn: 'root',
})
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone: true,
  imports: [
    RouterModule,
    FormsModule,
    NgOptimizedImage,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    MatSnackBarModule,
    MatRippleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDividerModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatMenuModule,
    MatBadgeModule,
  ],
})
export class LoginComponent {
  links = environment.links;
  loginForm: FormGroup;
  isLoading = false;
  @ViewChild('passwordInput') passwordInput: ElementRef;
  userId: string = '';
  isLightMode = computed(() => this.themeService.isLightMode());
  hidePassword = true;

  userSub: Subscription;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private userService: UserService,
    private fcmService: FCMService,
    private router: Router,
    private snackBar: MatSnackBar,
    private themeService: ThemeService
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });

    this.userSub = this.userService.userDetails$.subscribe((userData) => {
      if (userData) {
        this.fcmService.registerTokenV3(userData._id);
        // console.log("emitted user data in login sub", userData)
      } else {
        // console.log("user data null", userData)
      }
    });
  }

  onSubmit() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    const formValues = this.loginForm.value;

    this.isLoading = true;

    this.authService
      .mutate({
        loginInput: {
          username: formValues.email,
          password: formValues.password,
        },
      })
      .subscribe({
        next: (response) => {
          const loginResponse = response.data?.login;
          if (
            loginResponse &&
            loginResponse.access_token &&
            loginResponse.refresh_token
          ) {
            this.isLoading = false;
            this.authService.handleAuthentication(
              formValues.email,
              loginResponse.access_token,
              loginResponse.refresh_token
            );
            // queries useDetails and stores data in service for the rest of the app
            // this.userService.watch().valueChanges.pipe(
            //   tap(res=>{
            //     console.log('userQuery',res)
            //   })
            // )
            // .subscribe({
            //   next: (response)=>{
            //       this.userService.setUserDetails(JSON.stringify(response.data['user']));
            //       // console.log(response)
            //     // send FCM token to server
            //     // this.fcmService.registerToken(response.data.user._id);
            //     this.userId = response.data.user._id;
            //   }
            // });

            // this.fcmService.registerToken(this.userId);
            this.userService.fetchUserData();
            this.router.navigate(['app/']);
          }
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Error logging in:', error.message);
          this.loginForm.controls.password.reset();
          this.focusOnPasswordInput();
          this.snackBar.openFromComponent(ErrorSnackbarComponent, {
            data: { message: 'Login failed. Check your email and password' },
            duration: 3000,
          });
        },
      });
  }

  private focusOnPasswordInput() {
    setTimeout(() => {
      if (this.passwordInput) {
        this.passwordInput.nativeElement.focus();
      }
    }, 0);
  }

  togglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
  }
}
